// English translations
export default {
  sidebar: {
    menu: "Menu",
    adminSection: "Administration",
    dashboard: "Dashboard",
    employees: "Employees",
    workplaces: "Workplaces",
    statuses: "Statuses",
    automations: "Automations",
    tests: "Tests",
    export: "Export",
    asistent: "Assistant",
    requests: "Requests",
    activity: "Activity",
    broadcastSection: "Communication",
    inAppMessages: "Mass message",
    userManagement: "User Management",
    support: "Support",
    logout: "Log out"
  },
  common: {
    search: "Search...",
    add: "Add",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    confirm: "Confirm",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    actions: "Actions",
    filter: "Filter",
    sort: "Sort",
    noData: "No data",
    role: "Role",
    lightMode: "Light Mode",
    darkMode: "Dark Mode"
  },
  onboardingFlow: {
    welcome: {
      title: "Welcome to Effzone 👋",
      subtitle: "In a few minutes you'll be ready for your first check-in. We'll guide you through setup — workplace, employees and the QR poster.",
      highlightQr: "QR attendance",
      highlightSms: "SMS invites",
      highlightInsights: "Insights & payroll",
      start: "Let's go",
      skip: "Skip, I'll look around myself",
    },
    wizard: {
      title: "Quick setup",
      stepPersonalize: "Personalize",
      personalizeHeading: "Make Effzone yours",
      personalizeHint: "Pick your language and appearance — you can change everything anytime in the sidebar.",
      personalizeNote: "Changes apply instantly — try them out.",
      personalizeCompanyLabel: "Company name",
      personalizeCompanyPlaceholder: "e.g. Novak Bakery",
      personalizeCompanyRequired: "Enter your company name — employees will see it in the app and in the SMS invite.",
      languageLabel: "Admin language",
      themeLabel: "Appearance",
      themeLight: "Light",
      themeDark: "Dark",
      railHint: "Setup takes just a few minutes. Everything can be changed later — nothing is final.",
      stepWorkplace: "Workplace",
      stepEmployees: "Employees",
      stepPoster: "QR poster",
      stepDone: "Done",
      workplaceHeading: "Create your first workplace",
      workplaceHint: "The place where employees will check in — a store, warehouse, office…",
      workplaceLabel: "Workplace name",
      workplacePlaceholder: "e.g. Store Bratislava",
      workplaceExisting: "Using workplace:",
      workplaceSelectHint: "These are your workplaces — each one gets its own QR code. Add as many as you need.",
      employeesAssignLabel: "Assign to workplace",
      posterWorkplaceLabel: "Poster for workplace",
      workplaceAddAnother: "Add another workplace",
      workplaceCreateBtn: "Create",
      workplaceRequired: "Enter a workplace name or select an existing one.",
      employeesHeading: "Add employees",
      employeesHint: "Just a name and phone number — they'll use it to sign in to the mobile app. We'll automatically assign them to {workplace}.",
      employeeName: "Name",
      employeePhone: "Phone (+421...)",
      employeePosition: "Position (optional)",
      addRow: "Add another",
      importTitle: "Bulk import from a file",
      importSubtitle: "Upload an Excel or CSV with your employees — AI recognizes names, numbers and positions, whatever the columns look like.",
      importDrop: "Drop a file here or click to choose one",
      importFormats: "Excel (.xlsx), CSV or text file · max 5 MB",
      importOrText: "…or paste the list as text",
      importBadType: "Unsupported file type. Upload .xlsx, .csv or .txt (save old .xls files as .xlsx in Excel).",
      importPlaceholder: "Paste your employee list here…\n\ne.g.:\nJohn Smith, 0905 123 456, sales\nEva Small\t0911 222 333\twarehouse",
      importParse: "Recognize list",
      importParsing: "AI is reading the list…",
      importSuccess: "Recognized {count} employees — review and edit the details below.",
      importNone: "No employees could be recognized in the text. Try pasting a list with names and phone numbers.",
      importEmpty: "Paste a text with your employee list first.",
      sendInvite: "Send an SMS invite with the app download link",
      employeesNone: "Fill in at least one employee or skip this step.",
      employeesPartialFail: "Could not create: {names}. Check the details and try again, or skip this step.",
      posterHeading: "Print the QR poster",
      posterHint: "Hang it at the workplace — employees scan it with the app and attendance records itself. It includes instructions and an app download QR.",
      posterPrint: "Print A4 poster",
      posterPrinted: "Poster sent to print 🎉",
      posterLater: "You can print the poster anytime later in the workplace detail.",
      doneHeading: "All set! 🎉",
      doneText: "When an employee scans the QR code on the poster, you'll see the first check-in right on the dashboard.",
      doneSummaryWorkplace: "Workplace",
      doneSummaryEmployees: "Employees",
      doneSummaryInvites: "SMS invites",
      startTour: "Take a quick tour (1 min)",
      finish: "Start using Effzone",
      back: "Back",
      next: "Next",
      skipStep: "Skip this step",
      creating: "Working…",
      genericError: "Something went wrong. Please try again.",
    },
    tour: {
      next: "Next",
      prev: "Back",
      done: "Done",
      dashboardTitle: "Dashboard",
      dashboardDesc: "Your day at a glance — who's at work, hours worked and team trends.",
      employeesTitle: "Employees",
      employeesDesc: "Add employees, send SMS app invites and assign them to workplaces.",
      workplacesTitle: "Workplaces",
      workplacesDesc: "Each workplace has its own QR code. Customize the QR style and print the A4 poster here.",
      automationsTitle: "Automations",
      automationsDesc: "Auto-ending shifts, reminders and rules — attendance watches itself.",
      exportTitle: "Export",
      exportDesc: "Payroll-ready data in a few clicks — export attendance to Excel for any period.",
      asistentTitle: "AI assistant",
      asistentDesc: "Ask about attendance in plain language — the assistant answers from your data.",
      requestsTitle: "Requests",
      requestsDesc: "Employees send attendance change requests from the app; you approve them here.",
      activityTitle: "Activity",
      activityDesc: "A live feed of everything happening — check-ins, changes and company events.",
      profileTitle: "Your profile",
      profileDesc: "Account settings, language and dark mode live down here. That's it — let's go!",
    },
    checklist: {
      runWizard: "Launch the setup wizard",
      runTour: "Take the admin tour",
    },
  },
  addEmployeeDrawer: {
    title: "Add New Employee",
    name: "Name",
    position: "Position",
    email: "Email",
    phone: "Phone Number",
    phoneHelper: "The number the employee will use to sign in to the mobile app (e.g. 0905 123 456).",
    assignWorkplaces: "Assign to Workplaces",
    workplaceRequiredHint: "Without an assigned workplace the employee cannot sign in to the app.",
    noWorkplaceWarning: "No workplace selected — the employee will not be able to sign in.",
    sendInvite: "Send SMS invite to the app",
    sendInviteHint: "The employee will receive an SMS with a link to download the Effzone app.",
    create: "Create",
    errorRequired: "Name and phone number are required.",
    errorGeneric: "Failed to create the employee. Please try again.",
    inviteSmsFailed: "The employee was created, but the invite SMS failed to send. Share the link effzone.sk/mobile-app with them manually."
  },
  pages: {
    dashboard: {
      title: "Dashboard",
      quickActions: "Quick Actions",
      addEmployeesTitle: "Add Your Employees",
      addEmployeesDesc: "Start by adding your employees to the system to manage their attendance.",
      addEmployeesBtn: "Add Employees",
      addWorkplaceTitle: "Create a Workplace",
      addWorkplaceDesc: "Create workplaces and generate unique QR codes for attendance tracking.",
      addWorkplaceBtn: "Add Workplace",
      onboarding: {
        title: "Getting started — 4 steps to your first check-in",
        subtitle: "Done {done} of {total}",
        step1Title: "Create a workplace",
        step1Desc: "Just a name — location and geofencing can be added later.",
        step1Btn: "Create",
        step2Title: "Print the QR poster and put it up at the workplace",
        step2Desc: "In the workplace detail press “Print A4 poster” — it contains the QR code and instructions for employees.",
        step2Btn: "Open workplaces",
        step3Title: "Add employees",
        step3Desc: "Name + phone number. Don't forget to assign a workplace — without it the employee cannot sign in. An SMS with the app link is sent to the employee automatically.",
        step3Btn: "Add",
        step4Title: "First check-in",
        step4Desc: "The employee downloads the app, scans the QR at the workplace and signs in with their phone number. You'll see them right here on the dashboard.",
      },
      presentListTitle: "Currently at workplace",
      noPresent: "No employees are currently at the workplace.",
      noPosition: "Position not available",
      presence: {
        now: "Now",
        ofTeam: "of {total} people are at a workplace",
        noTeamYet: "You haven't added any employees yet",
        working: "Working",
        onBreak: "On break",
        away: "Away",
        nobodyInHint: "Nobody has checked in today yet.",
        addTeamCta: "Add employees"
      },
      feed: {
        title: "Activity",
        subtitle: "The team's last 20 events",
        updatedAt: "Updated at {time}",
        today: "Today",
        yesterday: "Yesterday",
        emptyTitle: "Nothing has happened yet",
        emptyHint: "Every check-in, break and check-out shows up here as soon as the first person checks in.",
        summary: {
          arrivals: "check-ins",
          breaks: "breaks",
          departures: "check-outs"
        },
        kinds: {
          arrival: "Checked in",
          departure: "Checked out",
          breakStart: "On break",
          breakEnd: "Back from break",
          autoEnd: "Ended by the system"
        }
      },
      period: {
        title: "How the team worked",
        teamLabel: "Team average",
        byEmployeeLabel: "By employee",
        autoEndedNote: "Ended by the system · {count} — excluded from average check-out and time at work",
        autoEndedShow: "Show",
        autoEndedHide: "Hide"
      },
      filters: {
        employeeAll: "Whole team",
        employeeLabel: "Employee"
      },
      kpis: {
        totalEmployees: "Total Employees",
        atWorkplace: "At Workplace",
        onBreak: "On Break",
        workedToday: "Worked Today",
        workplaces: "Workplaces",
        checkinsToday: "Check-ins today",
        checkinsBreakdown: "NFC {nfc} · QR {qr}",
        notPresent: "Not Present",
        onCustomStatus: "Custom Status"
      },
      workplacePresence: {
        title: "Who is where now",
        subtitle: "Currently present at workplaces",
        noData: "Nobody is at a workplace right now."
      },
      statusBreakdown: {
        title: "Absences and statuses",
        subtitle: "For the selected period",
        noData: "No status records for this period."
      },
      scoreboard: {
        title: "Employee overview",
        subtitle: "Worked hours, days and times for the selected period — click a header to sort",
        noData: "No attendance data for this period yet.",
        noDataHint: "The table fills in once employees start checking in and out.",
        colEmployee: "Employee",
        colHours: "Worked",
        colDays: "Days",
        colArrival: "Avg arrival",
        colDeparture: "Avg departure",
        colBreak: "Avg break"
      },
      status: {
        atWorkplace: "At Workplace",
        onBreak: "On Break"
      },
      charts: {
        weeklyTrend: "Attendance last 7 days",
        arrivalsToday: "Arrivals by hour",
        dayDetail: "Arrivals and departures by hour",
        weekly: "7 days",
        today: "Today",
        byDay: "By day",
        present: "Present",
        arrivals: "Arrivals",
        departures: "Departures",
        clickHint: "Click a bar to view employees for that day",
        noDayData: "No records for this day",
        noDayDataHint: "Try another day, or switch to the seven-day view.",
        tooltip: {
          presentCount: "Present · {count}",
          stillAtWork: "still in",
          more: "+{count} more",
          autoEndedNote: "Ended by the system — the check-out time is not real"
        },
        hoursTrendTitle: "Worked hours trend",
        hoursTrendSubtitle: "Net hours by week",
        netHours: "Worked hours",
        weekOf: "Week of {date}"
      },
      tasks: {
        title: "Tasks",
        subtitle: "What the team started and what got done",
        open: "Open",
        openHint: "{inProgress} in progress",
        overdue: "Overdue",
        overdueHint: "open with a due date in the past",
        completed7d: "Done (7 days)",
        created7dHint: "{created} created in the same window",
        recentLabel: "Recent activity",
        unassigned: "Unassigned",
        noRecent: "Nothing has happened yet.",
        noRecentHint: "New and completed tasks will show up here.",
        emptyTitle: "No tasks yet.",
        emptyHint: "A task is created in a chat or in the mobile app and always belongs to someone on the team. Once one exists, you will see it move here.",
        statuses: {
          pending: "To do",
          in_progress: "In progress",
          completed: "Done",
          cancelled: "Cancelled"
        },
        priorities: {
          low: "Low",
          medium: "Medium",
          high: "High"
        },
        detail: {
          title: "Task detail",
          assignee: "Assignee",
          createdBy: "Created by",
          created: "Created",
          dueDate: "Due",
          priority: "Priority",
          completed: "Completed",
          notes: "Note",
          attachments: "Attached brief",
          recordings: "Recordings",
          openFile: "Open file",
          showMore: "Show all",
          showLess: "Show less",
          truncated: "The file is longer — open the full version via the link in the header.",
          contentUnavailable: "The content could not be loaded; open the file via the link.",
          errorTitle: "Could not load the task detail.",
          errorHint: "Try again in a moment. If it persists, the task may have been deleted."
        },
        events: {
          created: "New",
          completed: "Done",
          cancelled: "Cancelled",
          overdue: "Overdue"
        }
      },
      devices: {
        title: "Team devices",
        summary: "{employees} employees with a registered device",
        platformsTab: "Platforms",
        appVersionsTab: "App versions",
        employeesLabel: "Employees",
        appVersionsLabel: "Installations",
        noData: "No device data yet.",
        noDataHint: "A device is recorded once an employee signs in on the mobile app or the web.",
        mobilePlatforms: "Mobile",
        allPlatforms: "All",
        platforms: {
          ios: "iOS",
          android: "Android",
          macos: "macOS",
          windows: "Windows",
          linux: "Linux",
          web: "Web",
          unknown: "Unknown"
        }
      },
      analytics: {
        averagesTitle: "Period averages",
        averagesTeamSubtitle: "Whole team",
        teamTitle: "Team performance",
        periodRange: "Data from {from} to {to}",
        sectionRoutine: "When they come to work",
        sectionWorkday: "How long they work",
        sectionActivity: "Team activity",
        avgArrival: "Arrival time",
        avgDeparture: "Departure time",
        avgWork: "Work time per day",
        avgBreak: "Break time",
        avgDays: "Days worked",
        activeEmployees: "Active employees",
        avgArrivalHint: "Average time employees arrive",
        avgDepartureHint: "Average time employees leave",
        avgWorkHint: "Net work time, breaks excluded",
        avgBreakHint: "How long a typical break lasts",
        avgDaysHint: "Average days worked per person",
        activeEmployeesHint: "How many people had at least one record",
        consistency: "Arrival stability",
        consistencyHint: "Lower number means more regular arrivals",
        consistencyUnit: "min spread",
        topByHours: "Most hours worked",
        topByDays: "Most days worked",
        singleEmployeeNote: "Rankings are available for the whole team.",
        noData: "Not enough data for this period yet",
        noDataHint: "Averages are calculated from the first completed shifts.",
        period7: "7 days",
        period14: "14 days",
        period30: "30 days",
        period90: "90 days",
        period365: "Year"
      }
    },
    employees: {
      title: "Employees",
      addEmployee: "Add Employee",
      searchPlaceholder: "Search by employee name...",
      list: {
        person: "Employee",
        group: {
          working: "At work",
          onBreak: "On a break",
          done: "Finished",
          away: "No record"
        },
        previousDay: "Previous day",
        nextDay: "Next day",
        pickDay: "Pick a day",
        today: "Today",
        shift: "Shift",
        lastSeen: "Last at work {date}",
        appSeen: "in the app {date}",
        neverUsed: "Has not used the app yet",
        noAttendanceYet: "Has the app, no attendance yet",
        worked: "Worked",
        workplace: "Workplace",
        notify: "Send a message",
        totalWorked: "{value} in total",
        emptyTitle: "No employee matches the filter",
        emptyHint: "Try changing the search, filter or date.",
        state: {
          working: "at work",
          onBreak: "on a break",
          done: "finished",
          away: "no record"
        }
      },
      insights: {
        period30: "30 days",
        period90: "90 days",
        period365: "Year",
        periodLabel: "Overview for {period}",
        loading: "Loading statistics...",
        noDevice: "No registered device",
        noAttendance: "No attendance in this period",
        avgRoutine: "{arrival} → {departure} · {work}/day · {days} days",
        deviceTitle: "Device",
        averagesTitle: "Averages",
        drawerTitle: "Period overview",
        avgBreak: "Average break",
        totalHours: "Total hours worked",
        systemVersion: "OS version",
        lastDeviceUpdate: "Last updated",
        avgArrivalShort: "Arrival",
        avgDepartureShort: "Departure",
        avgWorkShort: "Time / day",
        avgDaysShort: "Days",
        platformUnknown: "Unknown platform",
        platforms: {
          ios: "iOS",
          android: "Android",
          macos: "macOS",
          windows: "Windows",
          linux: "Linux",
          web: "Web"
        }
      }
    },
    employeeProfile: {
      backToList: "Employees",
      openPage: "Open page",
      noPosition: "Position not available",
      notFound: "This employee doesn't exist",
      notFoundHint: "They may have been deleted, or belong to another company.",
      presence: {
        working: "At work since {since} · {elapsed}",
        onBreak: "On break since {since}",
        lastSeen: "Last at work {when}",
        never: "No attendance yet"
      },
      actions: {
        message: "Message",
        edit: "Edit"
      },
      rhythm: {
        title: "Attendance pattern",
        total: "Total worked",
        daysWorked: "Days worked",
        verdict: {
          clockwork: "Arrives like clockwork",
          regular: "Keeps a regular pattern",
          varying: "Arrival times drift",
          irregular: "No settled pattern",
          noData: "Not enough data yet",
          sparse: "Showed up fewer than half the days",
          none: "No attendance in this period"
        },
        spread: "arrivals vary by ±{min} min",
        coverage: "showed up {worked} of {total} {unit}",
        unitWorkdays: "working days",
        unitDays: "days",
        avgDay: "{value} a day on average",
        arrivalAround: "arrives around {time}",
        missing: "{days} with no record",
        noEnd: "{days} with no clock-out",
        scopeMonth: "Month",
        scopeYear: "Year",
        previous: "Previous period",
        next: "Next period",
        dayOne: "day",
        dayFew: "days",
        dayMany: "days"
      },
      calendar: {
        less: "fewer hours",
        more: "more"
      },
      strip: {
        worked: "Worked",
        open: "In progress",
        auto: "Ended by the system",
        status: "Status",
        missing: "No record"
      },
      day: {
        nothing: "No record on this day",
        nothingHint: "Pick a day with attendance in the calendar to see how it went.",
        noEndShort: "Not clocked out",
        shiftCount: "{count} shifts",
        habitMarker: "dashed line = usual arrival and departure",
        autoNote: "The clock-out for this day was written by automation, not the employee \u2014 so hours worked are unknown.",
        deltaLater: "{value} later than usual",
        deltaEarlier: "{value} earlier than usual",
        deltaMore: "{value} more than average",
        deltaLess: "{value} less than average",
        deltaSame: "same as usual",
        noRecords: "Pick a day in the strip above to see how it went.",
        kinds: {
          arrival: "Checked in",
          departure: "Checked out",
          auto_end: "Ended by the system",
          break_start: "Break",
          status: "Status"
        }
      },
      attention: {
        title: "Worth knowing",
        autoEnded: "Missed check-out · {count} — the system closed the shift",
        staleOpen: "Open shift · {count} — still running from an earlier day",
        pendingRequests: "Requests waiting on you · {count}",
        statusDays: "{count} days",
        open: "Open",
        clearTitle: "Nothing needs your attention",
        clearHint: "No missed check-outs, open shifts or pending requests in this period."
      },
      facts: {
        title: "Facts",
        startDate: "Started",
        birthday: "Birthday",
        workplaces: "Workplaces",
        noWorkplace: "No workplace assigned",
        device: "Device",
        noDevice: "No device registered",
        appVersion: "App version",
        lastSeen: "Last at work"
      },
      message: {
        title: "Message to {name}",
        subject: "Subject",
        body: "Message",
        send: "Send",
        sent: "Message sent",
        failed: "Could not send the message"
      },
      edit: {
        title: "Edit employee",
        name: "Name",
        position: "Position",
        email: "Email",
        phone_number: "Phone number",
        workplaces: "Workplaces",
        noWorkplaceWarning: "Without a workplace the employee cannot sign in to the app.",
        saved: "Changes saved",
        failed: "Could not save the changes"
      }
    },
    employeeDrawer: {
      tabs: {
        timeline: "Timeline",
        plan: "Day Plan",
        message: "Message"
      },
      selectedDate: "Selected Date",
      dayPlan: {
        loading: "Loading day plan...",
        noPlan: "Employee has no plan for this day."
      }
    },
    workplaces: {
      title: "Workplaces",
      addWorkplace: "Add Workplace",
      searchPlaceholder: "Search by workplace name...",
      count: "workplaces",
      noResults: "No workplaces found."
    },
    automations: {
      title: "Automations",
      description: "Push notifications and automatic actions for long breaks or shifts.",
      lastRun: "Last run",
      neverRun: "Never run",
      settings: "Settings",
      history: "History",
      save: "Save",
      enable: "Enable",
      active: "Active",
      inactive: "Inactive",
      saved: "Settings saved.",
      enabled: "Automation enabled.",
      toggleError: "Failed to change automation state.",
      saveError: "Failed to save settings.",
      fetchError: "Failed to load automations.",
      types: {
        long_break: {
          title: "Break",
          description: "Notifies the employee if a break lasts too long."
        },
        long_shift_reminder: {
          title: "Long shift",
          description: "Reminds to end the shift after exceeding the hour limit."
        },
        auto_end_shift: {
          title: "Auto end shift",
          description: "Automatically ends the shift and sends a notification."
        }
      },
      fields: {
        durationMinutes: "Duration (minutes)",
        durationHours: "Duration (hours)",
        notificationTitle: "Notification title",
        notificationMessage: "Notification message",
        helperBreak: "Notify if the break is longer than this value.",
        helperShiftReminder: "Send a reminder if the shift is longer than this value.",
        helperAutoEnd: "Automatically end the shift after exceeding this value.",
        placeholdersEmployee: "You can use {{employee_name}}.",
        placeholdersHours: "You can use {{employee_name}} and {{hours}}."
      },
      historyPanel: {
        emptyTitle: "No history yet",
        emptyDesc: "This automation has not been executed yet.",
        success: "Success",
        failed: "Failed",
        unknownEmployee: "Unknown employee"
      }
    },
    requests: {
      title: "Change Requests",
      description: "Approve or reject change requests submitted by your employees.",
      searchPlaceholder: "Search by employee name...",
      approve: "Approve",
      reject: "Reject",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      noRequests: "No pending requests found."
    },
    reports: {
      title: "Support — reports",
      description: "Problem reports users submitted by shaking their phone. Once resolved, the user gets a message in their AI assistant chat.",
      filterOpen: "Open",
      filterResolved: "Resolved",
      filterAll: "All",
      statusOpen: "Open",
      statusResolved: "Resolved",
      empty: "No reports.",
      loadError: "Failed to load reports.",
      detailTitle: "Report detail",
      descriptionLabel: "Problem description",
      screenshotLabel: "Screenshot",
      diagnostics: "Diagnostics",
      detailScreen: "Screen",
      detailAppVersion: "App version",
      detailSystem: "System",
      detailDevice: "Device",
      createdAt: "Submitted",
      markResolved: "Mark as resolved",
      resolveDialogTitle: "Resolve report",
      resolveDialogText: "We'll send the user a message in their AI assistant chat that their report is resolved. You can add a short note (e.g. what you fixed).",
      resolveNoteLabel: "Note for the user (optional)",
      resolveNotePlaceholder: "E.g.: Fixed in the next release, thanks!",
      resolvedSuccess: "Report resolved, the user was notified.",
      resolveError: "Failed to resolve report.",
      resolvedAtLabel: "Resolved"
    },
    userManagement: {
      title: "User Management",
      description: "Manage all registered users",
      searchPlaceholder: "Search by username, email, or company..."
    },
    asistent: {
      heroTitle: "AI Assistant",
      heroSubtitle: "Uploaded documents form the knowledge base for the AI assistant in your employees' mobile app. Manage content here and test answers before rollout.",
      stepUpload: "Upload documents",
      stepManage: "Manage knowledge base",
      stepTest: "Test answers",
      uploadTitle: "Upload documents",
      uploadHint: "Supported formats",
      selectFile: "Choose file",
      uploadButton: "Upload",
      dragDropHint: "Drag a file here or click to browse",
      documentsTitle: "Knowledge base",
      documentsEmpty: "No documents uploaded yet. Upload your first document and the assistant will start using it.",
      chatTitle: "Test chat",
      chatHint: "Try how the assistant answers questions from uploaded documents.",
      chatPlaceholder: "Type a test question...",
      chatYou: "You",
      chatAssistant: "Assistant",
      uploadSuccess: "Document uploaded.",
      uploadSelectError: "Please select a file.",
      uploadFailed: "Upload failed.",
      chatFailed: "Could not get a response.",
      sendButton: "Send",
    },
    inAppMessages: {
      editor: {
        steps: {
          template: "Type",
          content: "Content",
          style: "Style",
          audience: "Audience"
        },
        templateSelector: {
          topBanner: "Top Banner",
          topBannerDesc: "Less intrusive, slides from top.",
          centerModal: "Center Modal",
          centerModalDesc: "High attention, centers on screen.",
          fullScreen: "Fullscreen",
          fullScreenDesc: "Maximum impact, covers everything."
        },
        contentEditor: {
          title: "Title",
          body: "Body Text",
          imageUrl: "Image URL",
          showImage: "Show Image",
          primaryButton: "Primary Button",
          secondaryButton: "Secondary Button",
          secondaryButtonHint: "This button only dismisses the message.",
          fullScreenSecondaryHint: "For full screen template, the button must be 'Close'.",
          magicGenerator: "AI Generator",
          magicPromptPlaceholder: "Enter message topic (e.g. 'Special offer 20% discount')",
          autoFill: "Auto Fill",
          generating: "Generating...",
          generatingShort: "Generating..."
        },
        actionEditor: {
          title: "Primary Action Settings",
          inAppScreen: "In-App Screen",
          externalLink: "External Link",
          screenName: "Screen Name",
          urlAddress: "URL Address",
          parameters: "Parameters (JSON)",
          parametersHint: "Optional data passed to the screen.",
          placeholderScreen: "e.g. ProductDetails",
          placeholderUrl: "https://..."
        },
        destinations: {
          selectDestination: "Where to navigate on tap",
          destinationHint: "Pick an in-app screen. Navigation params are preset.",
          home: { label: "Home", desc: "Main post feed" },
          chat_list: { label: "Chat", desc: "Conversation list" },
          attendance: { label: "Attendance", desc: "Calendar and shifts" },
          settings: { label: "Settings", desc: "Profile and app settings" },
          create_post: { label: "New post", desc: "Create a post" },
          qr_scanner: { label: "Scan QR", desc: "Attendance QR scanner" },
          colleagues: { label: "Colleagues", desc: "Colleague directory" },
          permissions: { label: "Permissions", desc: "App permissions" },
          wellbeing: { label: "Wellbeing", desc: "Feedback and wellbeing" },
          about: { label: "About app", desc: "App information" },
          search: { label: "Search", desc: "Global search" },
        },
        styleEditor: {
          colorPalette: "Color Palette",
          typography: "Typography",
          layout: "Layout",
          image: "Image",
          background: "Background",
          textColor: "Text Color",
          primaryBtnBg: "Primary Btn Bg",
          primaryBtnText: "Primary Btn Text",
          secondaryBtnBg: "Secondary Btn Bg",
          secondaryBtnText: "Secondary Btn Text",
          overlayColor: "Overlay Color",
          titleSize: "Title Size",
          bodySize: "Body Size",
          cornerRadius: "Corner Radius",
          imageSize: "Image Size",
          imageBorderRadius: "Image Border Radius"
        },
        footer: {
          nextStep: "Next Step",
          selectAudience: "Select audience to continue"
        },
        mobileTabs: {
          editor: "Editor",
          preview: "Preview"
        }
      },
      audience: {
        title: "Select Audience",
        searchPlaceholder: "Search employees...",
        filterActiveAttendance: "Only employees with active attendance",
        employees: "employees",
        employee: "employee",
        withFcmToken: "with FCM token",
        selectAll: "Select All",
        deselectAll: "Deselect All",
        noEmployeesFound: "No employees found",
        active: "Active",
        noFcmToken: "No FCM token",
        selected: "selected",
        previewAndSend: "Preview & Send"
      },
      preview: {
        title: "Preview & Send",
        back: "Back",
        edit: "Edit",
        selected: "Selected",
        withFcmToken: "With FCM Token",
        withoutToken: "Without Token",
        warningNoToken: "selected employee(s) do(es) not have FCM token and will be skipped.",
        pushNotification: "Push Notification (when app is in background)",
        inAppMessagePreview: "In-App Message Preview",
        realtimePreview: "Real-time Preview",
        realtimePreviewDesc: "See how your message looks on a device",
        iLikeIt: "I like it",
        iDontLikeIt: "I don't like it - Edit",
        approved: "Approved ✓",
        sendMessages: "Send Messages",
        sending: "Sending...",
        copy: "Copy",
        copied: "Copied!",
        payload: "Payload"
      },
      defaults: {
        title: "📢 Send messages to everyone at once",
        body: "Create your own message design and send it to all selected employees. Fast, simple and effective! ✨",
        buttonText: "Get Started",
        secondaryButtonText: "Close"
      },
      success: {
        messagesSent: "Messages sent!",
        successful: "successful",
        failed: "failed"
      },
      errors: {
        loadingEmployees: "Error loading employees. Please try again.",
        sendingMessages: "Error sending messages. Please try again.",
        generatingContent: "Error generating content. Please try again."
      }
    }
  }
};

